module.exports = __webpack_public_path__ + "img/smartphone.2423ecef.png";